export default __webpack_public_path__ + "static/media/053-one way.1028aeeb.png";